import React, { useEffect, useContext } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { LanguageContext } from '../Context/LanguageContext';

function Contact() {
  const { language, setLanguage } = useContext(LanguageContext);
  const isArabic = language === 'ar';

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className={`container-fluid p-0 contact ${isArabic ? 'text-end' : ''}`} dir={isArabic ? 'rtl' : 'ltr'} id="contact">
      <div className="container p-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="text-muted text-center w-100" data-aos="fade-down">
            {isArabic ? 'اتصل بنا' : 'Contact Us'}
          </h2>
        </div>

        <div className="row mt-5">
          {/* Left Column */}
          <div className="col-md-6" data-aos={isArabic ? 'fade-left' : 'fade-right'}>
            <p className="text-muted">
              {isArabic
                ? 'نحن سعداء بالتواصل معكم في أي وقت. لا تترددوا في إرسال استفساراتكم أو ملاحظاتكم عبر النموذج أو عبر المعلومات التالية.'
                : 'We are happy to hear from you anytime. Feel free to send your inquiries or feedback through the form or via the information below.'}
            </p>
            <ul className="list-unstyled d-flex flex-column gap-3 mt-3">
              <li className="d-flex align-items-center gap-2">
                <i className="fa-solid fa-location-dot me-2" style={{ color: "rgb(19, 30, 46)" }}></i>
                <span className='text-muted'>
                  {isArabic ? 'الأردن , عمان ' : 'Jordan, Amman'}
                </span>
              </li>
              <li className="d-flex align-items-center gap-2">
                <i className="fa-solid fa-phone me-2" style={{ color: "rgb(19, 30, 46)" }}></i>
                <span className='text-muted'>+962 796996828</span>
              </li>
              <li className="d-flex align-items-center gap-2">
                <i className="fa-solid fa-envelope me-2" style={{ color: "rgb(19, 30, 46)" }}></i>
                <span className='text-muted'>info@example.com</span>
              </li>
              <li className="d-flex align-items-center">
                <iframe
                  title="location-map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d392628.52026413433!2d35.61797077739416!3d31.835918822924345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151b5fb85d7981af%3A0x631c30c0f8dc65e8!2sAmman!5e1!3m2!1sen!2sjo!4v1753193625367!5m2!1sen!2sjo"
                  width="90%"
                  height="250"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </li>
            </ul>
          </div>

          {/* Right Column */}
          <div className="col-md-6" data-aos={isArabic ? 'fade-right' : 'fade-left'}>
            <form className='d-flex flex-column gap-3'>
              <div className="form-group">
                <label htmlFor="name" className="form-label text-muted">
                  {isArabic ? 'الاسم' : 'Name'}
                </label>
                <input type="text" className="form-control" id="name" />
              </div>
              <div className="form-group">
                <label htmlFor="email" className="form-label text-muted">
                  {isArabic ? 'البريد الإلكتروني' : 'Email'}
                </label>
                <input type="email" className="form-control" id="email" />
              </div>
              <div className="form-group">
                <label htmlFor="message" className="form-label text-muted">
                  {isArabic ? 'الرسالة' : 'Message'}
                </label>
                <textarea className="form-control" id="message" rows="7"></textarea>
              </div>
              <button type="submit" className="btn btn-contact mt-3 text-white">
                {isArabic ? 'إرسال' : 'Submit'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
